<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-md-12">
        <div class="title-wrapper">
          <h1 class="title-default">{{ isEditMode ? 'Editar Lista de Preço' : 'Nova Lista de Preço' }}</h1>
          <p class="welcome-message">
            <button mat-icon-button routerLink="../">
              <mat-icon>arrow_back</mat-icon>
            </button>
            {{ isEditMode ? 'Altere os dados da lista de preço' : 'Preencha os dados do registro' }}
          </p>
        </div>
      </div>
    </div>

    @if (isLoading) {
    <div class="row">
      <div class="col-12 mt-3">
        <!-- Seção Dados Gerais skeleton -->
        <div class="section-container">
          <div class="d-flex align-items-center gap-2 mb-3">
            <app-loading-box height="24" width="24"></app-loading-box>
            <app-loading-box height="20" width="150"></app-loading-box>
          </div>

          <!-- Descrição + Toggles -->
          <div class="row mb-3">
            <div class="col-12 col-md-6 mb-3">
              <app-loading-box height="56"></app-loading-box>
            </div>
            <div class="col-12 col-md-3 mb-3">
              <app-loading-box height="24" width="100"></app-loading-box>
            </div>
            <div class="col-12 col-md-3 mb-3">
              <app-loading-box height="24" width="120"></app-loading-box>
            </div>
          </div>



          <!-- Regras de Ajuste -->
          <app-loading-box height="16" width="200" class="mb-3"></app-loading-box>
          <div class="row mb-3">
            <div class="col-12 col-md-6 mb-3">
              <app-loading-box height="16" width="140"></app-loading-box>
              <div class="d-flex gap-3 mt-2">
                <app-loading-box height="20" width="120"></app-loading-box>
                <app-loading-box height="20" width="100"></app-loading-box>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12 col-md-3 mb-3">
              <app-loading-box height="56"></app-loading-box>
            </div>
            <div class="col-12 col-md-3 mb-3">
              <app-loading-box height="56"></app-loading-box>
            </div>
            <div class="col-12 col-md-3 mb-3">
              <app-loading-box height="56"></app-loading-box>
            </div>
          </div>
        </div>
      </div>
    </div>
    } @else {
    <!-- Banner Lista Padrão -->
    @if (isPadrao) {
    <app-alert-card type="info" [icon]="'info'" [closable]="false">
      Esta é a Lista de Preço Padrão do sistema. Ela vale para todos os produtos e todos os clientes
      automaticamente — novos produtos cadastrados também entram nesta lista de forma automática. Suas
      configurações não podem ser alteradas.
    </app-alert-card>
    }

    <form [formGroup]="form" (ngSubmit)="salvar()">
      <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

      <!-- ======================== Seção 1: Dados Gerais ======================== -->
      <div class="section-container" id="dados-gerais">
        <div class="section-title">
          <mat-icon>settings</mat-icon>
          <span>Dados Gerais</span>
        </div>

        <div class="row">
          <!-- Descrição + Toggles -->
          <div class="col-12 col-md-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Descrição</mat-label>
              <input matInput formControlName="descricao" required />
              @if (form.get('descricao')?.hasError('required')) {
              <mat-error>Descrição é obrigatória</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3 d-flex align-items-center gap-3">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isAtivo">
              {{ form.get('isAtivo')?.value ? 'Ativo' : 'Inativo' }}
            </mat-slide-toggle>
          </div>
          <div class="col-12 col-md-3 d-flex align-items-center gap-3">
            <mat-slide-toggle class="app-toggle-compact" formControlName="isPromocao">
              É Promoção
            </mat-slide-toggle>
          </div>
        </div>



        <!-- Regras de Ajuste de Preço -->
        <h4 class="subsection-title">Regras de Ajuste de Preço</h4>
        <div class="row">
          <div class="col-12 col-md-6">
            <label class="d-block mb-2 small">

              Método de Ajuste *
              <mat-icon class="help-icon-label"
                matTooltip="Automático: O sistema calcula o preço da lista com base no preço original + regra definida. Manual: Você define o preço de cada item individualmente."
                matTooltipPosition="right">info_outline</mat-icon>
            </label>
            <mat-radio-group formControlName="idMetodoAjustePreco" class="radio-group">
              @for (metodo of listaMetodosAjuste; track metodo.id) {
              <mat-radio-button [value]="metodo.id">{{ metodo.descricao }}</mat-radio-button>
              }
            </mat-radio-group>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Ação</mat-label>
              <mat-select formControlName="idAcaoAjustePreco" [disabled]="!isMetodoAutomatico">
                @for (acao of listaAcoes; track acao.id) {
                <mat-option [value]="acao.id">{{ acao.descricao }}</mat-option>
                }
              </mat-select>
              @if (form.get('idAcaoAjustePreco')?.hasError('required')) {
              <mat-error>A Ação é obrigatória</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Unidade</mat-label>
              <mat-select formControlName="idUnidadeAjustePreco" [disabled]="!isMetodoAutomatico">
                @for (unidade of listaUnidades; track unidade.id) {
                <mat-option [value]="unidade.id">{{ unidade.descricao }}</mat-option>
                }
              </mat-select>
              @if (form.get('idUnidadeAjustePreco')?.hasError('required')) {
              <mat-error>A Unidade é obrigatória</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Valor de Ajuste{{ isPercentual ? ' (%)' : '' }}</mat-label>
              <input matInput type="text" formControlName="valorAjuste" placeholder="0,00"
                [currencyMask]="valorAjusteMask" [disabled]="!isMetodoAutomatico" />
              @if (form.get('valorAjuste')?.hasError('required')) {
              <mat-error>O Valor de Ajuste é obrigatório</mat-error>
              }
              @if (form.get('valorAjuste')?.hasError('min')) {
              <mat-error>O valor de ajuste não pode ser negativo</mat-error>
              }
              @if (form.get('valorAjuste')?.hasError('max')) {
              <mat-error>O valor em percentual não pode ultrapassar 100%</mat-error>
              }
            </mat-form-field>
          </div>
        </div>



        <!-- Configurações de Escopo -->
        <h4 class="subsection-title">Configurações de Escopo</h4>
        <div class="row">
          <div class="col-12 col-md-5">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Como quer escolher os produtos</mat-label>
              <mat-select formControlName="isSelecaoProdutosAutomatica">
                <mat-option [value]="false">Selecionar manualmente</mat-option>
                <mat-option [value]="true">Selecionar todos os produtos automaticamente</mat-option>
              </mat-select>
              <mat-icon matSuffix class="help-icon-suffix"
                matTooltip="No método Automático, você pode incluir todos os produtos do catálogo de uma vez. No método Manual, a seleção de produtos é sempre individual — este campo é bloqueado automaticamente.">info_outline</mat-icon>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-5">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Para quais clientes esta lista pode ser usada</mat-label>
              <mat-select formControlName="isTodosClientes">
                <mat-option [value]="true">Todos clientes</mat-option>
                <mat-option [value]="false">Selecionar manualmente</mat-option>
              </mat-select>
              <mat-icon matSuffix class="help-icon-suffix"
                matTooltip="Defina se esta tabela é geral para toda a base de clientes ou exclusiva para um grupo selecionado.">info_outline</mat-icon>
            </mat-form-field>
          </div>
        </div>



        <!-- Refinamentos -->
        <h4 class="subsection-title">Refinamentos</h4>
        <div class="row">
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Arredondamento</mat-label>
              <mat-select formControlName="idTipoArredondamento" [disabled]="!isMetodoAutomatico">
                @for (tipo of listaTiposArredondamento; track tipo.id) {
                <mat-option [value]="tipo.id">{{ tipo.descricao }}</mat-option>
                }
              </mat-select>
              <mat-icon matSuffix class="help-icon-suffix"
                [matTooltip]="isMetodoAutomatico ? 'Define a forma de arredondamento aplicada ao preço calculado da lista.' : 'Campo bloqueado: no método Manual o preço é informado diretamente, não há cálculo automático para arredondar.'">info_outline</mat-icon>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data Início Vigência</mat-label>
              <input matInput [matDatepicker]="pickerInicio" formControlName="dataInicioVigencia"
                (input)="onDateInput($event, 'dataInicioVigencia')" />
              <mat-datepicker-toggle matIconSuffix [for]="pickerInicio"></mat-datepicker-toggle>
              <mat-datepicker #pickerInicio></mat-datepicker>
              @if (form.get('dataInicioVigencia')?.hasError('required')) {
              <mat-error>Data de início é obrigatória</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data Término Vigência</mat-label>
              <input matInput [matDatepicker]="pickerTermino" formControlName="dataTerminoVigencia"
                (input)="onDateInput($event, 'dataTerminoVigencia')" />
              <mat-datepicker-toggle matIconSuffix [for]="pickerTermino"></mat-datepicker-toggle>
              <mat-icon matSuffix class="help-icon-suffix"
                matTooltip="Opcional. Obrigatório quando 'É Promoção' estiver ativo.">info_outline</mat-icon>
              <mat-datepicker #pickerTermino></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>% Desconto Sugerido</mat-label>
              <input matInput type="text" formControlName="percentualDescontoSugerido" placeholder="0,00"
                [currencyMask]="percentageMask" />
              <mat-icon matSuffix class="help-icon-suffix"
                matTooltip="Percentual de desconto padrão preenchido automaticamente na venda.">info_outline</mat-icon>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-4">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>% Desconto Máximo</mat-label>
              <input matInput type="text" formControlName="percentualDescontoMaximo" placeholder="0,00"
                [currencyMask]="percentageMask" />
              <mat-icon matSuffix class="help-icon-suffix"
                matTooltip="Limite máximo de desconto permitido ao vendedor na venda.">info_outline</mat-icon>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- ======================== Seção 2: Itens na Lista ======================== -->
      <div class="section-container" id="itens-lista">
        <div class="section-title">
          <mat-icon>inventory_2</mat-icon>
          <span>Itens na Lista</span>
        </div>

        <app-lista-preco-cadastro-produtos [produtos]="listaProdutos" [isSelecaoAutomatica]="isSelecaoAutomatica"
          [isMetodoManual]="!isMetodoAutomatico" [isPadrao]="isPadrao" [configAjuste]="configAjuste"
          [isEditMode]="isEditMode" (produtosChange)="onProdutosChange($event)">
        </app-lista-preco-cadastro-produtos>
      </div>

      <!-- ======================== Seção 3: Clientes na Lista ======================== -->
      <div class="section-container" id="clientes-lista">
        <div class="section-title">
          <mat-icon>people</mat-icon>
          <span>Clientes</span>
        </div>

        <app-lista-preco-cadastro-clientes [clientes]="listaClientes" [isTodosClientes]="isTodosClientes"
          [isPadrao]="isPadrao" (clientesChange)="onClientesChange($event)">
        </app-lista-preco-cadastro-clientes>
      </div>
    </form>
    }
  </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" (cancelar)="cancelar()" (salvar)="salvar()">
</app-footer-action>